import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  emoji: '😰',
  text: 'Tienes más ovillos y patrones guardados de los que realmente utilizas porque nunca sabes cuál empezar.'
}, {
  emoji: '⏱️',
  text: 'Cuando por fin tienes una hora libre, la terminas gastando buscando inspiración en lugar de tejer.'
}, {
  emoji: '🧶',
  text: 'Compras lana porque te encanta… aunque todavía tengas mucha acumulada sin usar.'
}, {
  emoji: '💸',
  text: 'Sientes que desperdicias dinero comprando materiales nuevos cuando podrías aprovechar los que ya tienes.'
}, {
  emoji: '😓',
  text: 'Empiezas muchos proyectos con ilusión… pero la mayoría termina olvidado en un cajón.'
}, {
  emoji: '😩',
  text: 'Te encanta tejer, pero decidir qué hacer se ha vuelto más agotador que el propio tejido.'
}];
export function Recognize() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-191" data-mp="6gwdg5w4jm9d">
      <div className="mx-auto max-w-3xl text-center" data-id="element-192" data-mp="6f33ohq7slx5">
        <h2 className="font-display text-2xl font-black leading-tight text-plum-deep sm:text-4xl" data-id="element-193" data-mp="3jk0v0zvg0h9h">
          👉 ¿Te reconoces en estas situaciones?
        </h2>
        <p className="mt-3 text-sm font-semibold text-mauve sm:text-base" data-id="element-194" data-mp="39mw6wui1ebq1">
          Si respondes “Sí” a alguna… este sistema fue creado para ti.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-195" data-mp="3em92c3mz4r48">
        {items.map((it, i) => <motion.div key={it.text} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="flex items-start gap-4 rounded-2xl border border-mauve-soft/50 bg-white p-5 shadow-sm" data-id="element-196" data-mp="68a939rdzjuf" data-mpi={i}>
            <span className="text-3xl leading-none" data-id="element-197" data-mp="p49s3v2dzd1v">{it.emoji}</span>
            <p className="text-sm leading-relaxed text-plum/80" data-id="element-198" data-mp="tw9yo6cyp47f">{it.text}</p>
          </motion.div>)}
      </div>

      <p className="mx-auto mt-8 max-w-2xl text-center font-display text-lg font-semibold italic text-plum sm:text-xl" data-id="element-199" data-mp="13qp9swlqypdn">
        Y tú mereces disfrutar cada puntada… no perder tiempo decidiendo. →
      </p>
    </section>;
}